module.exports = __webpack_public_path__ + "static/media/red-back.1ba0145d.png";